import React from "react";
import { css } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import sharpanaLogo from "../assets/sharpana_logo_bold.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { isMobileApp, getMobileAppPlatform } from "@sharpana/shared/utils/web_environment";

interface BrandingBannerProps {
  className?: string;
}

const BrandingBanner: React.FC<BrandingBannerProps> = ({ className }) => {
  const navigate = useNavigate();

  const handlePlusClick = () => {
    navigate("/summarization-request");
  };

  return (
    <div
      className={className}
      css={css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 12px;
        width: 100%;
        user-select: none;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          font-weight: bold;
          color: white;
          position: relative;
        `}
      >
        <img
          src={sharpanaLogo}
          alt="S"
          css={css`
            height: 24px;
            margin-right: 0;
          `}
        />
        <span
          css={css`
            margin-left: -2px; /* Adjust this value to fine-tune the spacing */
            transform: translateY(3px);
            display: inline-block;
            font-family: "Newsreader", serif;
            font-weight: 500;
            font-size: 24px;
          `}
        >
          harpana
          {!(isMobileApp() && getMobileAppPlatform() === "ios") && (
            <span
            css={css`
              position: absolute;
              top: -8px;
              right: -20px;
              font-size: 10px;
              font-weight: 500;
              font-family: 'Inter', sans-serif;
              background-color: transparent;
              border: 1px solid white;
              border-radius: 4px;
              padding: 1px 4px;
              transform: scale(0.85);
              letter-spacing: 0.5px;
            `}
          >
            BETA
          </span>
          )}
        </span>
      </div>

      {/* <div
        onClick={handlePlusClick}
        css={css`
          font-size: 1.2rem;
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background-color: #5c575d;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background-color 0.2s ease;
          &:hover {
            background-color: #6c676d;
          }
        `}
      >
        <FontAwesomeIcon
          icon={faPlus}
          size="lg"
          color="white"
        />
      </div> */}
    </div>
  );
};

export default BrandingBanner;
